import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  LayoutDashboard, Euro, Receipt, UtensilsCrossed, ChefHat, Users, Wrench,
  TrendingUp, Camera, Trash2, ClipboardList, CalendarDays, PenLine, Wallet,
  Send, Settings, ChevronRight, ShoppingCart, PieChart, Landmark, Brain,
  Sparkles, Package, Palmtree, Gift, Snowflake, BookOpen, Calculator,
  CircleDot, Contact, ChevronDown, UserCog, Bot, Mail, Globe, Target,
  Search, Link, BarChart3, FileText, Zap, Clock, CheckSquare, QrCode,
  ExternalLink, Shield, Utensils, Check, Eye, MessageCircle
} from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

const HUB_SECTIONS = [
  {
    id: 'finances',
    label: 'Finances',
    desc: 'CA, factures, banques, salaires, budget',
    icon: Euro,
    color: '#C9A84C',
    items: [
      { id: 'dashboard', icon: LayoutDashboard, label: 'Tableau de bord', desc: 'Vue d\'ensemble mensuelle' },
      { id: 'ca', icon: Euro, label: 'Chiffre d\'affaires', desc: 'CA en temps reel' },
      { id: 'saisie', icon: PenLine, label: 'Saisie CA', desc: 'Saisie quotidienne' },
      { id: 'factures', icon: Receipt, label: 'Factures', desc: 'Scan & gestion factures' },
      { id: 'suivi', icon: CalendarDays, label: 'Bilan annuel', desc: 'Historique & tendances' },
      { id: 'tresorerie', icon: Wallet, label: 'Tresorerie', desc: 'Suivi bancaire & flux' },
      { id: 'banques', icon: Landmark, label: 'Banques', desc: 'Comptes bancaires' },
      { id: 'rapprochement', icon: PieChart, label: 'Rapprochement', desc: 'Rapprochement bancaire' },
      { id: 'fixes', icon: Wrench, label: 'Charges fixes', desc: 'Loyer, assurances...' },
      { id: 'salaires', icon: Users, label: 'Salaires', desc: 'Masse salariale' },
      { id: 'conges', icon: Palmtree, label: 'Conges', desc: 'Planning conges' },
      { id: 'budget', icon: Calculator, label: 'Budget', desc: 'Budget mensuel detaille' },
      { id: 'previsionnel', icon: TrendingUp, label: 'Previsionnel', desc: 'Projections & objectifs' },
      { id: 'ratios', icon: PieChart, label: 'Ratios Cles', desc: 'Food cost, salaires, loyer' },
    ],
  },
  {
    id: 'cuisine',
    label: 'Cuisine & Carte',
    desc: 'Menu, food cost, mercuriales, traiteur',
    icon: UtensilsCrossed,
    color: '#E07A5F',
    items: [
      { id: 'menu', icon: BookOpen, label: 'Carte & Menu', desc: 'Gestion de la carte' },
      { id: 'menu-du-jour', icon: CalendarDays, label: 'Menu du Jour', desc: 'Menu hebdomadaire' },
      { id: 'carte', icon: UtensilsCrossed, label: 'Food Cost', desc: 'Cout des plats' },
      { id: 'mercuriales', icon: ClipboardList, label: 'Mercuriales', desc: 'Prix fournisseurs' },
      { id: 'traiteur', icon: ChefHat, label: 'Traiteur', desc: 'Activite traiteur' },
      { id: 'congelateur', icon: Snowflake, label: 'Congelateur', desc: 'Suivi stock congeles' },
      { id: 'pertes', icon: Trash2, label: 'Pertes', desc: 'Suivi des pertes' },
      { id: 'optimisation', icon: Brain, label: 'Optim IA', desc: 'Analyse & conseils IA' },
    ],
  },
  {
    id: 'clients',
    label: 'Clients & Réservations',
    desc: 'Restaurant, fidelite, bons cadeaux',
    icon: Contact,
    color: '#009893',
    items: [
      { id: 'reservations', icon: CalendarDays, label: 'Reservations', desc: 'Gestion des resas' },
      { id: 'resa-calendar', icon: CalendarDays, label: 'Calendrier resa', desc: 'Planning visuel' },
      { id: 'resa-floor-plan', icon: LayoutDashboard, label: 'Plan de salle', desc: 'Disposition tables' },
      { id: 'clients', icon: Contact, label: 'Clients', desc: '3320 clients en base' },
      { id: 'bons-cadeaux', icon: Gift, label: 'Bons Cadeaux', desc: 'Vente en ligne Stripe' },
      { id: 'roue', icon: CircleDot, label: 'Jeu fidelite', desc: 'Roue de la chance' },
    ],
  },
  {
    id: 'prospection',
    label: 'Prospection B2B',
    desc: 'Conquérir de nouveaux clients pro',
    icon: Send,
    color: '#7C3AED',
    items: [
      { id: 'crm-campagne', icon: Send, label: 'Mes Campagnes', desc: 'Envoi & suivi temps réel' },
      { id: 'crm-inbox', icon: MessageCircle, label: 'Boîte retour', desc: 'Réponses · Désinscriptions' },
      { id: 'catalogue-traiteur', icon: FileText, label: 'Catalogue Traiteur', desc: 'Envoyer aux clients en 1 clic' },
      { id: 'email-templates', icon: FileText, label: 'Templates Email', desc: '30 modèles prêts' },
      { id: 'crm-dashboard', icon: BarChart3, label: 'Mes Prospects', desc: 'Pipeline & stats' },
      { id: 'crm-relances', icon: Clock, label: 'Relances', desc: 'Suivi auto' },
      { id: 'crm-recherche', icon: Search, label: 'Recherche', desc: 'Nouveaux prospects' },
    ],
  },
  {
    id: 'commercial',
    label: 'Propositions & Devis',
    desc: 'Suivi propositions traiteur',
    icon: FileText,
    color: '#0891B2',
    items: [
      { id: 'prop-dashboard', icon: FileText, label: 'Suivi Commercial', desc: 'Propositions & devis' },
      { id: 'rdv-commercial', icon: ClipboardList, label: 'RDV Commercial', desc: 'Premier contact guide' },
      { id: 'calendrier-commercial', icon: CalendarDays, label: 'Calendrier Commercial', desc: 'Vue mensuelle evenements' },
    ],
  },
  {
    id: 'outils',
    label: 'Outils & IA',
    desc: 'Messagerie, WhatsApp, IA, Telegram, site web',
    icon: Bot,
    color: '#8B5CF6',
    items: [
      { id: 'taches', icon: CheckSquare, label: 'Taches & Planning', desc: 'Calendrier, rappels Telegram' },
      { id: 'ia-cowork', icon: Bot, label: 'IA Cowork', desc: 'Assistant IA personnel' },
      { id: 'messagerie', icon: Mail, label: 'Messagerie', desc: 'Emails IMAP/SMTP' },
      { id: 'whatsapp', icon: Bot, label: 'WhatsApp', desc: 'Conversations clients IA' },
      { id: 'telegram', icon: Send, label: 'Telegram', desc: 'Bots & notifications' },
      { id: 'admin-site', icon: Globe, label: 'Site Web', desc: 'Gestion du site public' },
      { id: 'qrcode-menu', icon: QrCode, label: 'QR Code Menu', desc: 'Menu numerique' },
    ],
  },
  {
    id: 'equipe',
    label: 'Equipe & Acces',
    desc: 'Portails Chef / Salle / Employe + utilisateurs',
    icon: Users,
    color: '#0891B2',
    items: [
      { id: 'portal-chef', icon: ChefHat, label: 'Espace Chef', desc: 'Cuisine, recettes, couts', href: '/chef' },
      { id: 'portal-responsable', icon: Shield, label: 'Chef de Salle', desc: 'Bons cadeaux, scan', href: '/responsable' },
      { id: 'portal-employe', icon: CalendarDays, label: 'Employe', desc: 'Reservations, planning', href: '/employe' },
      { id: 'users', icon: UserCog, label: 'Utilisateurs', desc: 'Comptes & roles' },
      { id: 'settings-chef', icon: Settings, label: 'Param. Chef', desc: 'Interface chef' },
    ],
  },
];

export default function PatronHub({ setActiveTab }) {
  const navigate = useNavigate();
  const [expandedSection, setExpandedSection] = useState(null);
  const [pendingCount, setPendingCount] = useState(0);
  const [todayTasks, setTodayTasks] = useState([]);
  const [overdueTasks, setOverdueTasks] = useState([]);
  const [todayEvents, setTodayEvents] = useState([]);
  const [activeCampaign, setActiveCampaign] = useState(null);
  const [audiences, setAudiences] = useState(null);
  const [trackingStats, setTrackingStats] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('auth_token');
    fetch(`${API}/api/auth/users`, {
      headers: { 'Authorization': `Bearer ${token}` }
    }).then(r => r.json()).then(data => {
      if (Array.isArray(data)) setPendingCount(data.filter(u => u.status === 'pending').length);
    }).catch(() => {});

    // Fetch today's tasks
    const today = new Date().toISOString().split('T')[0];
    const month = today.slice(0, 7);
    fetch(`${API}/api/tasks?month=${month}`).then(r => r.json()).then(data => {
      if (Array.isArray(data)) {
        const priorityMap = { haute: 0, moyenne: 1, basse: 2 };
        const pending = data.filter(t => !t.completed);
        setTodayTasks(pending.filter(t => t.date === today).sort((a, b) => (priorityMap[a.priority] || 1) - (priorityMap[b.priority] || 1)));
        setOverdueTasks(pending.filter(t => t.date < today).sort((a, b) => a.date.localeCompare(b.date)));
      }
    }).catch(() => {});

    // Fetch today's external events
    fetch(`${API}/api/tasks/external-events?month=${month}`).then(r => r.json()).then(data => {
      if (Array.isArray(data)) {
        setTodayEvents(data.filter(e => e.date === today).sort((a, b) => (a.time || '99').localeCompare(b.time || '99')));
      }
    }).catch(() => {});

    // Fetch active CRM email campaigns and load their stats
    const loadActiveCampaign = async () => {
      try {
        const r = await fetch(`${API}/api/crm/campagnes-email`);
        const list = await r.json();
        if (!Array.isArray(list) || list.length === 0) return;
        const active = list.find(c => c.status === 'active');
        if (!active) return;
        const dr = await fetch(`${API}/api/crm/campagne-email/${active.id}`);
        const detail = await dr.json();
        setActiveCampaign(detail);
      } catch {}
    };
    loadActiveCampaign();
    const intervalId = setInterval(loadActiveCampaign, 30000); // refresh every 30s

    // Load audiences overview (counts of all segments)
    fetch(`${API}/api/audiences/overview`).then(r => r.json()).then(setAudiences).catch(() => {});

    // Load global tracking stats (open rate)
    fetch(`${API}/api/email-tracking/stats`).then(r => r.json()).then(setTrackingStats).catch(() => {});

    return () => clearInterval(intervalId);
  }, []);

  const toggleSection = (sectionId) => {
    setExpandedSection(prev => prev === sectionId ? null : sectionId);
  };

  return (
    <div className="max-w-5xl mx-auto" data-testid="patron-hub">
      {/* Header */}
      <div className="mb-8 text-center">
        <h1 className="text-2xl md:text-3xl font-bold text-[rgb(var(--lm-text))] tracking-tight" style={{ fontFamily: 'Georgia, serif' }}>
          LE MAS
        </h1>
        <p className="text-sm text-[rgb(var(--lm-text-muted))] mt-1 cursor-default select-none" onDoubleClick={() => setActiveTab('perso')}>Espace de pilotage</p>
        <button
          onClick={() => navigate('/hub')}
          className="mt-3 inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-[rgb(var(--lm-gold))]/10 hover:bg-[rgb(var(--lm-gold))]/20 border border-[rgb(var(--lm-gold))]/30 text-xs font-semibold text-[rgb(var(--lm-gold))] transition-all"
          data-testid="goto-new-hub"
        >
          <Sparkles size={12} /> Nouvelle interface (Hub clair)
        </button>
      </div>

      {/* Today's Agenda Widget */}
      {(todayTasks.length > 0 || overdueTasks.length > 0 || todayEvents.length > 0) && (
        <div className="mb-6 rounded-2xl border-2 border-[rgb(var(--lm-gold))]/20 bg-[rgb(var(--lm-card))] overflow-hidden" data-testid="hub-agenda-widget">
          <div className="px-4 py-3 flex items-center justify-between border-b border-[rgb(var(--lm-border))]/30">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg bg-[rgb(var(--lm-gold))]/15 flex items-center justify-center">
                <CalendarDays size={16} className="text-[rgb(var(--lm-gold))]" />
              </div>
              <div>
                <p className="text-sm font-bold text-[rgb(var(--lm-text))]">Agenda du jour</p>
                <p className="text-[10px] text-[rgb(var(--lm-text-muted))]">
                  {new Date().toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' })}
                </p>
              </div>
            </div>
            <button onClick={() => setActiveTab('taches')} className="text-[10px] text-[rgb(var(--lm-gold))] hover:underline" data-testid="hub-goto-tasks">
              Voir tout
            </button>
          </div>
          <div className="px-4 py-3 space-y-2 max-h-[280px] overflow-y-auto">
            {/* Overdue */}
            {overdueTasks.length > 0 && (
              <div className="space-y-1" data-testid="hub-overdue-tasks">
                <p className="text-[9px] uppercase tracking-wider text-red-400 font-bold">{overdueTasks.length} en retard</p>
                {overdueTasks.slice(0, 3).map(t => (
                  <HubTaskRow key={t.id} task={t} overdue setActiveTab={setActiveTab} />
                ))}
                {overdueTasks.length > 3 && <p className="text-[9px] text-red-400/60">+{overdueTasks.length - 3} autres</p>}
              </div>
            )}
            {/* Today tasks */}
            {todayTasks.length > 0 && (
              <div className="space-y-1" data-testid="hub-today-tasks">
                <p className="text-[9px] uppercase tracking-wider text-[rgb(var(--lm-text-muted))] font-bold">Taches du jour</p>
                {todayTasks.map(t => (
                  <HubTaskRow key={t.id} task={t} setActiveTab={setActiveTab} />
                ))}
              </div>
            )}
            {/* External events */}
            {todayEvents.length > 0 && (
              <div className="space-y-1" data-testid="hub-today-events">
                <p className="text-[9px] uppercase tracking-wider text-blue-400 font-bold">Calendrier</p>
                {todayEvents.map(e => (
                  <div key={e.id} className="flex items-center gap-2 px-2 py-1.5 rounded-lg bg-[rgb(var(--lm-surface))]/50">
                    <div className="w-1 h-6 rounded-full shrink-0" style={{ backgroundColor: e.color || '#3B82F6' }} />
                    <div className="flex-1 min-w-0">
                      <p className="text-xs text-[rgb(var(--lm-text))] truncate">{e.title}</p>
                      {e.time && <p className="text-[9px] text-[rgb(var(--lm-text-muted))]">{e.time}{e.location ? ` — ${e.location}` : ''}</p>}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      {/* Active CRM Email Campaign Widget */}
      {activeCampaign && (
        <div className="mb-6 rounded-2xl border-2 border-purple-400/30 bg-[rgb(var(--lm-card))] overflow-hidden" data-testid="hub-campaign-widget">
          <button onClick={() => setActiveTab('crm-campagne')} className="w-full text-left px-4 py-3 flex items-center justify-between border-b border-[rgb(var(--lm-border))]/30 hover:bg-purple-50/30 transition-colors">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg bg-purple-100 flex items-center justify-center">
                <Send size={16} className="text-purple-600" />
              </div>
              <div>
                <p className="text-sm font-bold text-[rgb(var(--lm-text))]">Campagne email en cours</p>
                <p className="text-[10px] text-[rgb(var(--lm-text-muted))] truncate max-w-[200px]">{activeCampaign.subject}</p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-[10px] text-purple-600 font-bold">Voir</span>
              <ChevronRight size={14} className="text-purple-500" />
            </div>
          </button>
          <div className="px-4 py-3">
            {(() => {
              const stats = activeCampaign.stats || {};
              const sent = stats.envoye || 0;
              const programmed = stats.programme || 0;
              const errored = stats.erreur || 0;
              const total = sent + programmed + errored + (stats.annule || 0);
              const pct = total > 0 ? Math.round((sent / total) * 100) : 0;
              return (
                <>
                  <div className="flex items-center justify-between text-[10px] mb-2">
                    <span className="font-bold text-[rgb(var(--lm-text))]">{sent} / {total} envoyés</span>
                    <span className="text-purple-600 font-bold">{pct}%</span>
                  </div>
                  <div className="h-2 bg-purple-100 rounded-full overflow-hidden mb-3">
                    <div className="h-full bg-gradient-to-r from-purple-400 to-purple-600 transition-all duration-500" style={{ width: `${pct}%` }} />
                  </div>
                  <div className="flex gap-2 text-[9px] flex-wrap">
                    {sent > 0 && <span className="px-2 py-0.5 rounded-full bg-green-100 text-green-700 font-semibold">✓ {sent} envoyé{sent > 1 ? 's' : ''}</span>}
                    {programmed > 0 && <span className="px-2 py-0.5 rounded-full bg-blue-100 text-blue-700 font-semibold">⏳ {programmed} en attente</span>}
                    {errored > 0 && <span className="px-2 py-0.5 rounded-full bg-red-100 text-red-700 font-semibold">✗ {errored} erreur{errored > 1 ? 's' : ''}</span>}
                  </div>
                </>
              );
            })()}
          </div>
        </div>
      )}

      {/* Audiences / Listes / Segments — Quick view */}
      {audiences && (
        <div className="mb-6 rounded-2xl border-2 border-[rgb(var(--lm-gold))]/20 bg-[rgb(var(--lm-card))] overflow-hidden" data-testid="hub-audiences-widget">
          <div className="px-4 py-3 flex items-center justify-between border-b border-[rgb(var(--lm-border))]/30">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg bg-[rgb(var(--lm-gold))]/15 flex items-center justify-center">
                <Users size={16} className="text-[rgb(var(--lm-gold))]" />
              </div>
              <div>
                <p className="text-sm font-bold text-[rgb(var(--lm-text))]">Mes Audiences</p>
                <p className="text-[10px] text-[rgb(var(--lm-text-muted))]">Listes & segments contactables</p>
              </div>
            </div>
            <button onClick={() => setActiveTab('crm-campagne')} className="text-[10px] text-[rgb(var(--lm-gold))] hover:underline font-bold">Lancer campagne</button>
          </div>
          <div className="p-3 grid grid-cols-2 gap-2">
            {/* Prospects B2B Section */}
            <button onClick={() => setActiveTab('crm-pipeline')} className="group p-3 rounded-xl bg-purple-50 dark:bg-purple-900/20 border border-purple-200/50 hover:border-purple-400 transition-colors text-left" data-testid="audience-contacts66">
              <p className="text-[9px] uppercase tracking-wide text-purple-600 font-bold">CONTACTS66</p>
              <p className="text-2xl font-black text-purple-900 dark:text-purple-200 mt-1">{audiences.prospects_b2b.tags.contacts66}</p>
              <p className="text-[9px] text-purple-700/70 dark:text-purple-300/70">prospects B2B partenaires</p>
            </button>
            <button onClick={() => setActiveTab('crm-pipeline')} className="group p-3 rounded-xl bg-amber-50 dark:bg-amber-900/20 border border-amber-200/50 hover:border-amber-400 transition-colors text-left" data-testid="audience-premium">
              <p className="text-[9px] uppercase tracking-wide text-amber-600 font-bold">PREMIUM</p>
              <p className="text-2xl font-black text-amber-900 dark:text-amber-200 mt-1">{audiences.prospects_b2b.tags.premium}</p>
              <p className="text-[9px] text-amber-700/70 dark:text-amber-300/70">prospects haute valeur</p>
            </button>

            {/* Clients B2C Section */}
            <button onClick={() => setActiveTab('clients')} className="group p-3 rounded-xl bg-emerald-50 dark:bg-emerald-900/20 border border-emerald-200/50 hover:border-emerald-400 transition-colors text-left" data-testid="audience-zenchef-optin">
              <p className="text-[9px] uppercase tracking-wide text-emerald-600 font-bold">ZENCHEF · OPT-IN ✓</p>
              <p className="text-2xl font-black text-emerald-900 dark:text-emerald-200 mt-1">{audiences.clients_b2c.opt_in_email}</p>
              <p className="text-[9px] text-emerald-700/70 dark:text-emerald-300/70">clients restaurant marketing OK</p>
            </button>
            <button onClick={() => setActiveTab('clients')} className="group p-3 rounded-xl bg-slate-50 dark:bg-slate-800/40 border border-slate-200 hover:border-slate-400 transition-colors text-left" data-testid="audience-zenchef-noopt">
              <p className="text-[9px] uppercase tracking-wide text-slate-600 dark:text-slate-400 font-bold">ZENCHEF · NO-OPTIN</p>
              <p className="text-2xl font-black text-slate-900 dark:text-slate-200 mt-1">{audiences.clients_b2c.no_optin}</p>
              <p className="text-[9px] text-slate-700/70 dark:text-slate-400/70">contact direct uniquement</p>
            </button>
            <button onClick={() => setActiveTab('clients')} className="group p-3 rounded-xl bg-rose-50 dark:bg-rose-900/20 border border-rose-200/50 hover:border-rose-400 transition-colors text-left" data-testid="audience-vip">
              <p className="text-[9px] uppercase tracking-wide text-rose-600 font-bold">VIP · 10+ VISITES</p>
              <p className="text-2xl font-black text-rose-900 dark:text-rose-200 mt-1">{audiences.clients_b2c.vip_10_plus}</p>
              <p className="text-[9px] text-rose-700/70 dark:text-rose-300/70">vos meilleurs clients</p>
            </button>
            <button onClick={() => setActiveTab('clients')} className="group p-3 rounded-xl bg-blue-50 dark:bg-blue-900/20 border border-blue-200/50 hover:border-blue-400 transition-colors text-left" data-testid="audience-habitues">
              <p className="text-[9px] uppercase tracking-wide text-blue-600 font-bold">HABITUÉS · 4-9</p>
              <p className="text-2xl font-black text-blue-900 dark:text-blue-200 mt-1">{audiences.clients_b2c.habitues_4_9}</p>
              <p className="text-[9px] text-blue-700/70 dark:text-blue-300/70">à fidéliser</p>
            </button>
          </div>
          {(audiences.rgpd.blacklist > 0 || audiences.clients_b2c.unsubscribed > 0) && (
            <div className="px-4 py-2 bg-red-50 dark:bg-red-900/10 border-t border-red-100 dark:border-red-900/20 flex items-center gap-2 text-[10px]">
              <span className="text-red-500">🚫</span>
              <span className="text-red-700 dark:text-red-300 font-semibold">{audiences.rgpd.blacklist + audiences.clients_b2c.unsubscribed} désinscrits — exclus automatiquement de toutes les campagnes</span>
            </div>
          )}
        </div>
      )}

      {/* Email Tracking Widget — open rate & warm leads */}
      {trackingStats && trackingStats.total_sent > 0 && (
        <div className="mb-6 rounded-2xl border-2 border-purple-300/30 bg-gradient-to-br from-purple-50/40 to-white overflow-hidden" data-testid="hub-tracking-widget">
          <div className="px-4 py-3 flex items-center justify-between border-b border-purple-100">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg bg-purple-100 flex items-center justify-center">
                <Eye size={16} className="text-purple-600" />
              </div>
              <div>
                <p className="text-sm font-bold text-[rgb(var(--lm-text))]">Tracking ouvertures</p>
                <p className="text-[10px] text-[rgb(var(--lm-text-muted))]">Qui a lu vos emails ?</p>
              </div>
            </div>
            <span className="text-xl font-black text-purple-700">{trackingStats.open_rate}%</span>
          </div>
          <div className="p-3 grid grid-cols-3 gap-2">
            <div className="text-center">
              <p className="text-lg font-black text-gray-900">{trackingStats.total_sent}</p>
              <p className="text-[9px] text-[rgb(var(--lm-text-muted))]">Envoyés</p>
            </div>
            <div className="text-center">
              <p className="text-lg font-black text-purple-700">{trackingStats.opened}</p>
              <p className="text-[9px] text-purple-600">Ouverts</p>
            </div>
            <div className="text-center">
              <p className="text-lg font-black text-amber-600">{trackingStats.multi_open_3plus}</p>
              <p className="text-[9px] text-amber-600">🔥 Très chauds (3+)</p>
            </div>
          </div>
          {trackingStats.top_openers && trackingStats.top_openers.length > 0 && (
            <div className="px-3 pb-3">
              <p className="text-[9px] uppercase tracking-wider text-purple-600 font-bold mb-1.5">🎯 Top leads chauds (à appeler)</p>
              <div className="space-y-1">
                {trackingStats.top_openers.slice(0, 5).map((o, i) => (
                  <div key={i} className="flex items-center gap-2 px-2 py-1.5 bg-white rounded-lg border border-purple-100">
                    <span className="text-[10px] font-bold text-gray-700 truncate flex-1">{o.prospect_nom}</span>
                    <span className="text-[9px] text-gray-500 truncate max-w-[120px]">{o.prospect_email}</span>
                    <span className="px-1.5 py-0.5 bg-purple-100 text-purple-700 rounded-full text-[9px] font-bold">{o.open_count}× lu</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}

      {/* Section tiles grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {HUB_SECTIONS.map((section) => {
          const SectionIcon = section.icon;
          const isExpanded = expandedSection === section.id;

          return (
            <div key={section.id} className="col-span-1" style={{ gridColumn: isExpanded ? '1 / -1' : undefined }}>
              {/* Section card */}
              <button
                onClick={() => toggleSection(section.id)}
                className={`w-full text-left rounded-2xl border-2 transition-all duration-300 overflow-hidden ${
                  isExpanded
                    ? 'shadow-lg'
                    : 'hover:shadow-md hover:-translate-y-0.5'
                }`}
                style={{
                  borderColor: isExpanded ? section.color : 'rgb(var(--lm-border))',
                  background: isExpanded ? section.color + '08' : 'rgb(var(--lm-card))',
                }}
                data-testid={`hub-section-${section.id}`}
              >
                <div className="p-5 flex items-center gap-4">
                  <div
                    className="w-14 h-14 rounded-xl flex items-center justify-center shrink-0"
                    style={{ background: section.color + '18' }}
                  >
                    <SectionIcon size={26} style={{ color: section.color }} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-base font-bold text-[rgb(var(--lm-text))]">{section.label}</p>
                    <p className="text-xs text-[rgb(var(--lm-text-muted))] mt-0.5">{section.desc}</p>
                  </div>
                  <ChevronDown
                    size={20}
                    className="text-[rgb(var(--lm-text-muted))] transition-transform duration-300 shrink-0"
                    style={{ transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)', color: isExpanded ? section.color : undefined }}
                  />
                </div>
              </button>

              {/* Expanded sub-items */}
              {isExpanded && (
                <div className="mt-3 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-2 animate-slide-up">
                  {section.items.map((item) => {
                    const Icon = item.icon;
                    const hasBadge = item.id === 'users' && pendingCount > 0;

                    return (
                      <button
                        key={item.id}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (item.href) {
                            navigate(item.href);
                          } else {
                            setActiveTab(item.id);
                          }
                        }}
                        className="group relative p-4 rounded-xl bg-[rgb(var(--lm-card))] border border-[rgb(var(--lm-border))]/40 hover:shadow-md transition-all text-left"
                        data-testid={`hub-nav-${item.id}`}
                        onMouseEnter={(e) => { e.currentTarget.style.borderColor = section.color + '60'; }}
                        onMouseLeave={(e) => { e.currentTarget.style.borderColor = ''; }}
                      >
                        <div className="flex items-start gap-3">
                          <div
                            className="w-10 h-10 rounded-lg flex items-center justify-center shrink-0"
                            style={{ background: section.color + '15' }}
                          >
                            <Icon size={18} style={{ color: section.color }} />
                          </div>
                          <div className="flex-1 min-w-0">
                            <p className="text-sm font-semibold text-[rgb(var(--lm-text))]">{item.label}</p>
                            <p className="text-[11px] text-[rgb(var(--lm-text-muted))] mt-0.5 leading-snug">{item.desc}</p>
                          </div>
                          {item.href && <ExternalLink size={14} className="text-[rgb(var(--lm-text-muted))] shrink-0 mt-1" />}
                        </div>
                        {hasBadge && (
                          <span className="absolute top-2 right-2 w-5 h-5 rounded-full bg-red-500 text-white text-[9px] font-bold flex items-center justify-center animate-pulse">
                            {pendingCount}
                          </span>
                        )}
                      </button>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}


const PRIORITY_STYLES = {
  haute: { color: '#ef4444', icon: '!!' },
  moyenne: { color: '#f59e0b', icon: '!' },
  basse: { color: '#22c55e', icon: '' },
};

function HubTaskRow({ task, overdue, setActiveTab }) {
  const [completed, setCompleted] = useState(task.completed || false);
  const [loading, setLoading] = useState(false);
  const pri = PRIORITY_STYLES[task.priority] || PRIORITY_STYLES.moyenne;

  const toggleDone = async (e) => {
    e.stopPropagation();
    if (loading) return;
    setLoading(true);
    try {
      const res = await fetch(`${API}/api/tasks/${task.id}/toggle`, { method: 'POST' });
      const data = await res.json();
      setCompleted(data.completed);
    } catch {
      // silent
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className={`w-full flex items-center gap-2 px-2 py-1.5 rounded-lg transition-colors ${overdue ? 'bg-red-500/5' : 'bg-[rgb(var(--lm-surface))]/50'} ${completed ? 'opacity-50' : ''}`}
      data-testid={`hub-task-${task.id}`}
    >
      <button
        onClick={toggleDone}
        className={`shrink-0 w-5 h-5 rounded-md border-2 flex items-center justify-center transition-all ${completed ? 'bg-[rgb(var(--lm-green))] border-[rgb(var(--lm-green))]' : 'border-[rgb(var(--lm-border))] hover:border-[rgb(var(--lm-gold))]'}`}
        aria-label={completed ? 'Marquer non fait' : 'Marquer comme fait'}
        data-testid={`hub-task-toggle-${task.id}`}
        disabled={loading}
      >
        {completed && <Check size={12} className="text-white" strokeWidth={3} />}
      </button>
      <button
        onClick={() => setActiveTab('taches')}
        className="flex-1 min-w-0 text-left flex items-center gap-2 hover:opacity-80"
      >
        <div className="w-1 h-6 rounded-full shrink-0" style={{ backgroundColor: pri.color }} />
        <div className="flex-1 min-w-0">
          <p className={`text-xs truncate ${completed ? 'line-through text-[rgb(var(--lm-text-muted))]' : overdue ? 'text-red-400' : 'text-[rgb(var(--lm-text))]'}`}>{task.title}</p>
          <p className="text-[9px] text-[rgb(var(--lm-text-muted))]">
            {task.time || ''} {overdue ? `retard ${task.date?.slice(5)}` : ''}
          </p>
        </div>
        {task.priority === 'haute' && !completed && (
          <span className="text-[8px] px-1.5 py-0.5 rounded-full bg-red-500/10 text-red-400 font-bold shrink-0">HAUTE</span>
        )}
      </button>
    </div>
  );
}
